import { useTranslation } from 'react-i18next'

import styles from './TeacherDrawer.module.scss'

const TeacherDrawer = ({
  drawer,
  gradeVal,
  setGradeVal,
  gradeComment,
  setGradeComment,
  onClose,
  onAccept,
  onReturn,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.drawerOverlay} onClick={onClose}>
      <div className={`unv-card ${styles.drawer}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.drawerHeader}>
          <h2>{drawer.assignment?.title || t('assignments.task_default_title')}</h2>
          <button className="unv-btn unv-btn--ghost" onClick={onClose}>
            {t('assignments.close_btn')}
          </button>
        </div>

        <div className={styles.drawerBody}>
          <div className={styles.section}>
            <div className={styles.muted}>{t('assignments.student_label')}</div>
            <div>
              {drawer.submission.student_name || drawer.submission.student?.full_name || '—'}
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.muted}>{t('assignments.answer_text')}</div>
            <div className={styles.preBox}>
              {drawer.submission.content || drawer.submission.text || '—'}
            </div>
          </div>
          {Array.isArray(drawer.submission.files) && drawer.submission.files.length > 0 && (
            <div className={styles.section}>
              <div className={styles.muted}>{t('assignments.attachments_label')}</div>
              {drawer.submission.files.map((f) => (
                <a
                  key={f.id || f.url}
                  className="unv-btn unv-btn--ghost"
                  href={f.url || f.file}
                  target="_blank"
                  rel="noreferrer"
                >
                  {f.name || t('assignments.file_default')}
                </a>
              ))}
            </div>
          )}
          <div className={styles.section}>
            <label>{t('assignments.grade_label')}</label>
            <input
              type="number"
              className="unv-input"
              value={gradeVal}
              onChange={(e) => setGradeVal(e.target.value)}
            />
          </div>
          <div className={styles.section}>
            <label>{t('assignments.comment_label')}</label>
            <textarea
              rows="4"
              className="unv-input"
              value={gradeComment}
              onChange={(e) => setGradeComment(e.target.value)}
            />
          </div>
          <div className={styles.drawerActions}>
            <button className="unv-btn unv-btn--ghost" onClick={onReturn}>
              {t('assignments.return_btn')}
            </button>
            <button className="unv-btn" onClick={onAccept}>
              {t('assignments.accept_btn')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherDrawer
